/**
 * JEAN D'ARCEL | Cosmetique — Main Theme JavaScript
 * Matches the jd-* classes used in theme sections
 */

(function () {
  'use strict';

  const on = (element, event, handler) => {
    if (element) element.addEventListener(event, handler);
  };

  /* ============================================================
     HEADER — Sticky scroll behavior
     ============================================================ */
  function initStickyHeader() {
    const header = document.querySelector('.jd-header-wrapper[data-sticky="true"]');
    if (!header) return;
    let lastScroll = 0;
    window.addEventListener('scroll', function () {
      const cur = window.scrollY;
      if (cur > 80) {
        header.classList.add('scrolled');
        if (cur > lastScroll && cur > 200) header.classList.add('hidden');
        else header.classList.remove('hidden');
      } else {
        header.classList.remove('scrolled', 'hidden');
      }
      lastScroll = cur;
    }, { passive: true });
  }

  /* ============================================================
     ANNOUNCEMENT BAR — Dismissible
     ============================================================ */
  function initAnnouncementBar() {
    const bar = document.querySelector('.announcement-bar');
    const closeBtn = document.querySelector('.announcement-bar__close');
    if (!bar || !closeBtn) return;
    if (sessionStorage.getItem('jda-announcement-dismissed')) {
      bar.classList.add('announcement-bar--hidden');
      return;
    }
    closeBtn.addEventListener('click', () => {
      bar.classList.add('announcement-bar--hidden');
      sessionStorage.setItem('jda-announcement-dismissed', 'true');
    });
  }

  /* ============================================================
     SEARCH OVERLAY
     ============================================================ */
  function initSearchOverlay() {
    const searchBtn = document.querySelector('[data-search-trigger]');
    const searchOverlay = document.querySelector('.jd-search-overlay');
    const searchInput = document.querySelector('.jd-search-input');
    if (!searchOverlay) return;
    function open() { searchOverlay.classList.add('active'); if (searchInput) setTimeout(() => searchInput.focus(), 100); }
    function close() { searchOverlay.classList.remove('active'); }
    if (searchBtn) searchBtn.addEventListener('click', open);
    searchOverlay.addEventListener('click', (e) => { if (e.target === searchOverlay || e.target.closest('[data-search-overlay]')) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ============================================================
     MOBILE MENU
     ============================================================ */
  function initMobileMenu() {
    const menuBtn = document.querySelector('[data-mobile-menu-trigger]');
    const menuBackdrop = document.querySelector('.jd-mobile-backdrop');
    const menuPanel = document.querySelector('.jd-mobile-menu');
    if (!menuBtn || !menuBackdrop || !menuPanel) return;
    function open() { menuBackdrop.classList.add('active'); menuPanel.classList.add('active'); document.body.style.overflow = 'hidden'; }
    function close() { menuBackdrop.classList.remove('active'); menuPanel.classList.remove('active'); document.body.style.overflow = ''; }
    menuBtn.addEventListener('click', open);
    menuBackdrop.addEventListener('click', close);
    menuPanel.querySelectorAll('[data-mobile-menu-close]').forEach(btn => btn.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ============================================================
     CART DRAWER
     ============================================================ */
  function initCartDrawer() {
    const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
    const cartBackdrop = document.querySelector('.jd-cart-backdrop');
    const cartDrawer = document.querySelector('.jd-cart-drawer');
    if (!cartBackdrop || !cartDrawer) return;
    function open() { cartBackdrop.classList.add('active'); cartDrawer.classList.add('active'); document.body.style.overflow = 'hidden'; }
    function close() { cartBackdrop.classList.remove('active'); cartDrawer.classList.remove('active'); document.body.style.overflow = ''; }
    cartTriggers.forEach(trigger => trigger.addEventListener('click', open));
    cartBackdrop.addEventListener('click', close);
    cartDrawer.querySelectorAll('[data-cart-close]').forEach(btn => btn.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ============================================================
     SLIDESHOW — Touch swipe + keyboard
     ============================================================ */
  function initSlideshow() {
    document.querySelectorAll('.jd-slideshow').forEach(function (el) {
      const slider = el.querySelector('[data-slider]');
      if (!slider) return;
      let current = 0;
      const total = slider.children.length;
      if (total <= 1) return;

      const dots = el.querySelectorAll('.jd-slideshow__dot');
      const autoplay = el.dataset.autoplay === 'true';
      const speed = parseInt(el.dataset.speed, 10) || 6000;
      let timer = null;

      function goTo(idx) {
        current = ((idx % total) + total) % total;
        slider.style.transform = 'translateX(-' + (current * 100) + '%)';
        dots.forEach(function (d, i) {
          d.classList.toggle('active', i === current);
          d.style.width = i === current ? '32px' : '16px';
        });
      }

      window['jdSlideTo_' + el.id] = goTo;

      if (autoplay) {
        timer = setInterval(function () { goTo(current + 1); }, speed);
        el.addEventListener('mouseenter', function () { clearInterval(timer); });
        el.addEventListener('mouseleave', function () { timer = setInterval(function () { goTo(current + 1); }, speed); });
      }

      let startX = 0;
      el.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (Math.abs(diff) > 50) goTo(current + (diff > 0 ? 1 : -1));
      }, { passive: true });
    });
  }

  /* ============================================================
     QUANTITY INPUT — Custom element
     ============================================================ */
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="number"]');
      this.buttons = this.querySelectorAll('button');
      if (!this.input) return;
      this.init();
    }
    init() {
      this.buttons.forEach((button) => {
        on(button, 'click', () => {
          const current = parseInt(this.input.value, 10) || 1;
          if (button.name === 'plus') {
            this.input.value = current + 1;
          } else if (button.name === 'minus' && current > 1) {
            this.input.value = current - 1;
          }
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }
  }
  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
  }

  /* ============================================================
     PRODUCT FORM — Add to cart with AJAX
     ============================================================ */
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form[data-type="add-to-cart-form"]');
      this.submitButton = this.querySelector('[type="submit"]');
      if (!this.form) return;
      this.init();
    }
    init() {
      on(this.form, 'submit', async (e) => {
        e.preventDefault();
        if (this.submitButton) {
          this.submitButton.disabled = true;
          this.submitButton.classList.add('button--loading');
        }
        try {
          const formData = new FormData(this.form);
          const response = await fetch(window.theme.routes.cart_add_url + '.js', {
            method: 'POST',
            headers: { 'Accept': 'application/javascript' },
            body: formData
          });
          if (!response.ok) {
            const error = await response.json();
            throw new Error(error.description || 'Add to cart failed');
          }
          await this.refreshCartDrawer();
          document.querySelector('.jd-cart-backdrop')?.classList.add('active');
          document.querySelector('.jd-cart-drawer')?.classList.add('active');
          document.body.style.overflow = 'hidden';
        } catch (error) {
          console.error('Cart error:', error);
        } finally {
          if (this.submitButton) {
            this.submitButton.disabled = false;
            this.submitButton.classList.remove('button--loading');
          }
        }
      });
    }
    async refreshCartDrawer() {
      try {
        const resp = await fetch('/cart.js');
        const cart = await resp.json();
        const countEls = document.querySelectorAll('.jd-header__cart-count');
        countEls.forEach(el => {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      } catch (e) { console.error(e); }
    }
  }
  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  /* ============================================================
     VARIANT SELECTS
     ============================================================ */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.selects = this.querySelectorAll('select');
      this.jsonScript = this.querySelector('script[type="application/json"]');
      if (!this.jsonScript) return;
      try { this.variants = JSON.parse(this.jsonScript.textContent); } catch (e) { return; }
      this.init();
    }
    init() {
      this.selects.forEach(select => on(select, 'change', () => this.updateVariant()));
    }
    updateVariant() {
      const selectedOptions = [...this.selects].map(s => s.value);
      const variant = this.variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
      if (!variant) return;
      const sectionId = this.dataset.section;
      const form = this.closest('section')?.querySelector('product-form')?.querySelector('form');
      if (form) {
        const idInput = form.querySelector('input[name="id"]');
        if (idInput) { idInput.value = variant.id; idInput.disabled = false; }
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          const label = submitBtn.querySelector('span');
          if (label) label.textContent = variant.available
            ? (window.themeStrings?.addToCart || 'Adauga in cos')
            : (window.themeStrings?.soldOut || 'Epuizat');
        }
      }
    }
  }
  if (!customElements.get('variant-selects')) {
    customElements.define('variant-selects', VariantSelects);
  }

  /* ============================================================
     FACET FILTERS
     ============================================================ */
  class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.init();
    }
    init() {
      if (!this.form) return;
      this.form.querySelectorAll('input, select').forEach(input => {
        on(input, 'change', () => this.onSubmitForm());
      });
    }
    onSubmitForm() {
      const formData = new FormData(this.form);
      const params = new URLSearchParams(formData).toString();
      const url = window.location.pathname + '?' + params;
      window.history.pushState({}, '', url);
      this.renderPage(url);
    }
    async renderPage(url) {
      const grid = document.getElementById('product-grid');
      if (!grid) return;
      try {
        const response = await fetch(url);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.getElementById('product-grid');
        if (newGrid) grid.innerHTML = newGrid.innerHTML;
      } catch (e) { console.error(e); }
    }
  }
  if (!customElements.get('facet-filters-form')) {
    customElements.define('facet-filters-form', FacetFiltersForm);
  }

  /* ============================================================
     INITIALIZATION
     ============================================================ */
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(() => {
    initStickyHeader();
    initAnnouncementBar();
    initSearchOverlay();
    initMobileMenu();
    initCartDrawer();
    initSlideshow();
  });

})();
